/* Ardor A-Frame Sign Builder: options, live price, artwork layout, 3D preview, proof approval, cart and quote. Ardor Printing.
   Ported from ardor-banner-builder-v2.js on 2026-10-06. Loaded by sections/ardor-aframe-builder.liquid. */
/* v2 (Oct 8, 2026): copy of ardor-aframe-builder.js with small hooks (marked v2) for ardor-aframe-layers.js:
   text, clipart and exact-logo layers drawn on the 2D layout, 3D, proof and print files, and the AI A-frame hand-off.
   Loaded by sections/ardor-aframe-builder-ws.liquid. The live ardor-aframe-builder.js is unchanged. */
(function () {
  'use strict';
  var root = document.querySelector('[data-abb-root]');
  if (!root || root.__abb) return;
  root.__abb = true;

  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var CONF = {};
  try { CONF = JSON.parse($('[data-abb-config]').textContent); } catch (e) { CONF = {}; }
  if (!CONF.variants || typeof CONF.variants !== 'object') CONF.variants = {};
  var PHONE = CONF.phone || '(425) 629-0796';

  // ---------- frames and prices ----------
  // W and H are the printed sign size in inches. Prices come from the hidden Shopify product (CONF.variants, cents);
  // FALLBACK holds the same numbers so a price always shows.
  var MODELS = [
    { id: 'standard', sku: 'STANDARD', name: 'Standard Signicade', sub: 'Printed vinyl applied to the frame', W: 24, H: 36, signType: 'adhesive vinyl mounted on the frame', insert: false, colors: ['white'], orders: ['frame'] },
    { id: 'simpo', sku: 'SIMPO', name: 'Simposign II', sub: 'Lightweight, changeable signs', W: 22, H: 28, signType: '4mm coroplast insert', insert: true, colors: ['white'], orders: ['frame', 'inserts'] },
    { id: 'deluxe', sku: 'DELUXE', name: 'Deluxe Signicade', sub: 'Changeable signs slide in and out', W: 24, H: 36, signType: '4mm coroplast insert', insert: true, colors: ['white', 'black'], orders: ['frame', 'inserts'] }
  ];
  var FALLBACK = {
    'AF-DELUXE-F2': 36574, 'AF-DELUXE-F1': 34050, 'AF-DELUXE-I2': 9586, 'AF-DELUXE-I1': 7132,
    'AF-STANDARD-F2': 25268, 'AF-STANDARD-F1': 23946,
    'AF-SIMPO-F2': 27366, 'AF-SIMPO-F1': 24944, 'AF-SIMPO-I2': 8310, 'AF-SIMPO-I1': 6494,
    'AF-DESIGN': 5000
  };
  var COLORS = { white: 'White', black: 'Black' };
  var SAFE = 0.75; // inches from the edge to the dashed red safe line
  var MAX_FILE = 25 * 1024 * 1024;

  var S = { model: 'standard', order: 'frame', sides: 1, color: 'white', qty: 1, back: false, design: false, delivery: '', backMode: 'same', face: 'front', artVer: 0 };
  var ART = { front: null, back: null };
  var eng = null;

  function modelById(id) { for (var i = 0; i < MODELS.length; i++) if (MODELS[i].id === id) return MODELS[i]; return MODELS[0]; }
  function num(v, d) { var n = parseFloat(v); return isFinite(n) ? n : d; }

  function skuFor(m, order, sides) { return 'AF-' + m.sku + '-' + (order === 'inserts' ? 'I' : 'F') + sides; }
  function cfg(over) {
    var s = Object.assign({}, S, over || {});
    var m = modelById(s.model);
    var order = m.orders.indexOf(s.order) >= 0 ? s.order : 'frame';
    var sides = Number(s.sides) === 2 ? 2 : 1;
    var color = m.colors.indexOf(s.color) >= 0 ? s.color : m.colors[0];
    return { model: m, order: order, frame: order === 'frame', sides: sides, color: color, Wi: m.W, Hi: m.H, sku: skuFor(m, order, sides), qty: Math.max(1, Math.min(500, Math.round(num(s.qty, 1)))), artVer: s.artVer };
  }

  function variantFor(sku) { var v = CONF.variants[sku]; return v && v.id ? v : null; }
  function cents(sku) {
    var v = variantFor(sku), p = v ? Math.round(Number(v.price)) : NaN;
    return isFinite(p) && p > 0 ? p : (FALLBACK[sku] || 0);
  }
  function price(c) {
    var unit = cents(c.sku), fee = S.design ? cents('AF-DESIGN') : 0, v = variantFor(c.sku);
    return { unit: unit / 100, charged: (unit * c.qty + fee) / 100, fee: fee / 100, vid: v ? v.id : null, disc: 0 };
  }
  function fromPrice(m) { return Math.min(cents(skuFor(m, 'frame', 1)), cents(skuFor(m, 'frame', 2))) / 100; }

  function money(n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n) { var r = Math.round(n * 100) / 100; return Math.abs(r - Math.round(r)) < 0.001 ? String(Math.round(r)) : String(r); }

  // ---------- labels ----------
  function sizeLabel(c) { return fmt(c.Wi) + ' x ' + fmt(c.Hi) + ' in'; }
  function frameLabel(c) { return c.frame ? c.model.name : 'Replacement inserts only for ' + c.model.name; }
  function signsLabel(c) { return c.sides === 2 ? '2 signs (front and back)' : '1 sign (front)'; }
  function deliveryLabel() { return S.delivery === 'pickup' ? 'Pick up in Snohomish (free)' : 'Ship it (free ground)'; }
  function frontLabel(c) { return c.sides === 2 && S.backMode !== 'different' ? 'Front (same art on the back)' : 'Front'; }

  // ---------- option buttons ----------
  function optBtn(opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'abb-opt' + (opts.chip ? ' abb-opt--chip' : '');
    b.setAttribute('aria-pressed', opts.on ? 'true' : 'false');
    if (opts.data) b.setAttribute('data-' + opts.data[0], String(opts.data[1]));
    if (opts.disabled) b.disabled = true;
    if (opts.html) b.innerHTML = opts.html; else b.textContent = opts.label;
    b.addEventListener('click', opts.pick);
    return b;
  }
  function fill(el, nodes) {
    if (!el) return;
    var ae = document.activeElement, idx = -1;
    if (ae && el.contains(ae)) idx = Array.prototype.indexOf.call(el.children, ae);
    el.textContent = '';
    nodes.forEach(function (n) { el.appendChild(n); });
    if (idx >= 0 && el.children[idx]) { try { el.children[idx].focus({ preventScroll: true }); } catch (e) {} }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function set(patch) { Object.assign(S, patch); render(); }
  function setText(sel, t) { var el = $(sel); if (el) el.textContent = t; }

  function pickModel(id) {
    var before = modelById(S.model), m = modelById(id);
    var patch = { model: m.id };
    if (m.orders.indexOf(S.order) < 0) patch.order = 'frame';
    if (m.colors.indexOf(S.color) < 0) patch.color = m.colors[0];
    // keep the art, but fit it to the new sign shape
    if (m.W !== before.W || m.H !== before.H) {
      [ART.front, ART.back].forEach(function (a) { if (a) { a.mode = a.kind === 'image' ? 'fill' : 'fit'; a.rcx = 0.5; a.rcy = 0.5; } });
      patch.artVer = S.artVer + 1;
    }
    set(patch);
  }

  // ---------- artwork ----------
  function artFor(face) {
    if (face === 'back' || face === 'back-flat') {
      var c = cfg();
      if (c.sides === 2 && S.backMode === 'different') return ART.back;
      return ART.front;
    }
    return ART.front;
  }
  // v2: text, clipart and logo layers added in the builder (ardor-aframe-layers.js). Same face rule as artFor.
  function layerFace(face) { return (face === 'back' || face === 'back-flat') && cfg().sides === 2 && S.backMode === 'different' ? 'back' : 'front'; }
  function hasLayers(f) { return !!(window.ArdorAFrameLayers && window.ArdorAFrameLayers.has(f)); }
  var LAYER_NOTE = 'Print file made from a flattened image of the artwork plus text and clipart added in the builder.';
  // print job for one sign: with text or clipart, the face is one flattened image (artwork + layers) at the exact sign size
  function layerJob(mkJob, a, f, Wi, Hi, notes) {
    if (!hasLayers(f)) return Promise.resolve(mkJob(a));
    return window.ArdorAFrameLayers.composite(f, Wi, Hi, a).then(function (r) {
      var job = mkJob({ file: r.file, name: r.file.name, kind: 'image', bg: '#FFFFFF' });
      job.faces[0].geomFor = function () { return { x: 0, y: 0, w: Wi, h: Hi }; };
      if (notes.indexOf(LAYER_NOTE) < 0) notes.push(LAYER_NOTE);
      return job;
    });
  }
  function layerSummary(c) {
    var LY = window.ArdorAFrameLayers; if (!LY || !LY.list) return '';
    var keys = c.sides === 2 && S.backMode === 'different' ? ['front', 'back'] : ['front'];
    return keys.map(function (k) {
      var items = (LY.list(k) || []).map(function (o) { return o.kind === 'text' ? '"' + String(o.text || '').replace(/\s+/g, ' ').trim() + '"' + (o.font ? ' (' + o.font + ')' : '') : (o.label || o.kind); });
      return items.length ? (keys.length > 1 ? (k === 'front' ? 'Front: ' : 'Back: ') : '') + items.join(', ') : '';
    }).filter(Boolean).join('; ');
  }

  function geom(a, Wi, Hi) {
    var ia = a.natW / a.natH;
    var fillW = Math.max(Wi, Hi * ia);
    var fitW = Math.min(Wi, Hi * ia);
    if (a.mode === 'fill') { a.rw = fillW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    else if (a.mode === 'fit') { a.rw = fitW / Wi; a.rcx = 0.5; a.rcy = 0.5; }
    var w = a.rw * Wi, h = w / ia;
    return { x: a.rcx * Wi - w / 2, y: a.rcy * Hi - h / 2, w: w, h: h, fillW: fillW, fitW: fitW };
  }

  function paintFace(ctx, Wi, Hi, face) {
    var a = artFor(face), lf = layerFace(face);
    if (!a) { // v2: no artwork, but text or clipart: white sign with the layers
      if (!hasLayers(lf)) return false;
      ctx.save(); ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi); ctx.restore();
      window.ArdorAFrameLayers.paint(ctx, Wi, Hi, lf);
      return true;
    }
    ctx.save();
    ctx.fillStyle = a.bg || '#FFFFFF';
    ctx.fillRect(0, 0, Wi, Hi);
    if (a.img) {
      var g = geomForArt(a, a.natW, a.natH, Wi, Hi);
      ctx.drawImage(a.img, g.x, g.y, g.w, g.h);
    } else {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#3D3A36'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      var fs = Math.min(Hi * 0.12, Wi * 0.07);
      ctx.font = '700 ' + fs + 'px Arial, sans-serif';
      ctx.fillText(a.loading ? 'LOADING YOUR FILE' : 'YOUR FILE', Wi / 2, Hi * 0.44);
      ctx.font = '400 ' + (fs * 0.5) + 'px Arial, sans-serif';
      var nm = a.name.length > 40 ? a.name.slice(0, 37) + '...' : a.name;
      ctx.fillText(nm, Wi / 2, Hi * 0.52);
      if (!a.loading) ctx.fillText('Preview not available', Wi / 2, Hi * 0.58);
    }
    ctx.restore();
    if (hasLayers(lf)) window.ArdorAFrameLayers.paint(ctx, Wi, Hi, lf); // v2
    return true;
  }

  function loadFile(file, face) {
    var err = $('[data-abb-error]');
    if (!file) return;
    if (file.size > MAX_FILE) { toast(file.name + ' is over 25 MB. Order with a smaller file, then email the full file to info@ardorprinting.com.'); return; }
    var isImg = /^image\/(png|jpeg|webp|svg\+xml|gif)$/.test(file.type) || /\.(png|jpe?g|webp|svg|gif)$/i.test(file.name);
    var a = { file: file, name: file.name, kind: isImg ? 'image' : 'file', img: null, natW: 1, natH: 1, mode: isImg ? 'fill' : 'fit', rw: 1, rcx: 0.5, rcy: 0.5, bg: '#FFFFFF' };
    if (!isImg) { previewFile(a, face); return; }
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      a.img = img; a.natW = img.naturalWidth || img.width || 1000; a.natH = img.naturalHeight || img.height || 1500;
      ART[face] = a; S.artVer++; render();
    };
    img.onerror = function () { a.kind = 'file'; a.mode = 'fit'; previewFile(a, face); };
    img.src = url;
    if (err) err.hidden = true;
  }

  // PDF, AI, EPS, TIFF and PSD files: draw a preview so customers see their art in 3D and on the proof.
  // The art viewer file is a straight copy of the banner one, so it still sets window.ArdorBannerArtView.
  var artViewP = null;
  function loadArtView() {
    if (window.ArdorBannerArtView) return Promise.resolve(window.ArdorBannerArtView).then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
    if (!artViewP) artViewP = new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.artviewUrl; sc.async = true;
      sc.onload = function () { window.ArdorBannerArtView ? res(window.ArdorBannerArtView) : rej(new Error('art view')); };
      sc.onerror = function () { artViewP = null; rej(new Error('art view')); };
      document.head.appendChild(sc);
    });
    return artViewP.then(function (av) { av.config({ lib: CONF.pdfjsUrl, worker: CONF.pdfjsWorkerUrl }); return av; });
  }
  function previewFile(a, face) {
    a.loading = true; a.noPreview = false;
    ART[face] = a; S.artVer++; render();
    a.ready = loadArtView().then(function (av) { return av.preview(a.file, { maxPx: 2400 }); }).then(function (r) {
      if (r && r.ok) { a.img = r.canvas; a.natW = r.natW || r.canvas.width; a.natH = r.natH || r.canvas.height; a.src = r.kind; a.vectorPdf = r.vectorPdf || null; }
      else { a.noPreview = true; a.reason = (r && r.reason) || 'type'; }
    }).catch(function () { a.noPreview = true; a.reason = 'error'; }).then(function () {
      a.loading = false;
      if (ART.front === a || ART.back === a) { S.artVer++; render(); }
    });
  }
  function noPreviewText(a) {
    var tail = ' You can still order with this file, and we\'ll email you a proof to approve before we print.';
    if (a.reason === 'ai-no-pdf') return 'This AI file was saved without PDF content, so we can\'t show it here. In Illustrator, use File > Save As, check "Create PDF Compatible File" and upload it again, or upload a PDF, PNG or JPG.' + tail;
    if (a.reason === 'eps') return 'We can\'t show this EPS file here, usually because it has live text or effects. To see it on your sign, upload it as a PDF or AI file, or outline the text and save the EPS again.' + tail;
    if (a.reason === 'locked') return 'This PDF is password protected, so we can\'t show it here. Upload a copy without a password to see it on your sign.' + tail;
    if (a.reason === 'blank') return 'This file looks empty, so there\'s nothing to show. Check that you picked the right file.' + tail;
    return 'We can\'t show this file here. Upload a PDF, AI, EPS, PNG or JPG to see it on your sign.' + tail;
  }
  function needsEmailProof() {
    if (S.design) return true;
    var c = cfg(), used = [ART.front]; if (c.sides === 2 && S.backMode === 'different') used.push(ART.back);
    return used.some(function (x) { return x && x.noPreview; });
  }

  // ---------- flat sign drawing (2D editor and the 3D sign faces) ----------
  function drawFlat(ctx, c, Wi, Hi, face, guides) {
    if (!paintFace(ctx, Wi, Hi, face)) {
      ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#A3A3AD'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Hi * 0.1, Wi * 0.065) + 'px Arial, sans-serif';
      ctx.fillText(S.design ? 'We design it for you' : 'Your artwork goes here', Wi / 2, Hi / 2);
    }
    if (!guides) return;
    var lw = Math.max(Wi, Hi) / 600;
    ctx.save();
    ctx.setLineDash([]); ctx.lineWidth = lw * 2.6; ctx.strokeStyle = 'rgba(255,255,255,0.7)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([lw * 6, lw * 4]); ctx.lineWidth = lw * 1.5; ctx.strokeStyle = 'rgba(189,37,44,0.95)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([]);
    ctx.restore();
  }

  // ---------- flat layout editor ----------
  var lay = { canvas: null, scale: 1, drag: false, lx: 0, ly: 0 };
  function drawLayout() {
    var cv = lay.canvas; if (!cv) return;
    var c = cfg();
    var Wi = c.Wi, Hi = c.Hi;
    var frame = cv.parentNode;
    var cs = window.getComputedStyle(frame), isApp = root.classList.contains('abb--app');
    var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0), padY = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
    var maxW = isApp ? Math.max(60, (frame.clientWidth || 400) - padX) : Math.max(160, (frame.clientWidth || 400) - 20);
    var maxH = isApp ? Math.max(40, (frame.clientHeight || 300) - padY) : 420;
    var cssW = maxW, cssH = cssW * Hi / Wi;
    if (cssH > maxH) { cssH = maxH; cssW = cssH * Wi / Hi; }
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var pw = Math.round(cssW * dpr), ph = Math.round(cssH * dpr);
    cv.style.width = Math.round(cssW) + 'px'; cv.style.height = Math.round(cssH) + 'px';
    if (cv.width !== pw || cv.height !== ph) { cv.width = pw; cv.height = ph; }
    lay.scale = cssW / Wi;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cv.width / Wi, 0, 0, cv.height / Hi, 0, 0);
    drawFlat(ctx, c, Wi, Hi, S.face === 'back' ? 'back-flat' : 'front', true);
  }

  function editingArt() { return S.face === 'back' ? (S.backMode === 'different' ? ART.back : null) : ART.front; }

  function bindLayout() {
    lay.canvas = $('[data-abb-layout-canvas]');
    if (!lay.canvas) return;
    var cv = lay.canvas;
    cv.addEventListener('pointerdown', function (e) {
      var a = editingArt(); if (!a || !a.img) return;
      lay.drag = true; lay.lx = e.clientX; lay.ly = e.clientY;
      try { cv.setPointerCapture(e.pointerId); } catch (er) {}
      e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (!lay.drag) return;
      var a = editingArt(); if (!a) return;
      var c = cfg();
      var dx = (e.clientX - lay.lx) / lay.scale, dy = (e.clientY - lay.ly) / lay.scale;
      lay.lx = e.clientX; lay.ly = e.clientY;
      if (a.mode !== 'custom') { geom(a, c.Wi, c.Hi); a.mode = 'custom'; }
      a.rcx += dx / c.Wi; a.rcy += dy / c.Hi;
      a.rcx = Math.max(-0.5, Math.min(1.5, a.rcx)); a.rcy = Math.max(-0.5, Math.min(1.5, a.rcy));
      S.artVer++; renderArtOnly();
    });
    var end = function () { lay.drag = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    var sc = $('[data-abb-scale]');
    sc.addEventListener('input', function () {
      var a = editingArt(); if (!a || !a.img) return;
      var c = cfg(); var g = geom(a, c.Wi, c.Hi);
      a.mode = 'custom'; a.rw = (parseFloat(sc.value) / 100) * g.fillW / c.Wi;
      S.artVer++; renderArtOnly();
    });
    $('[data-abb-fill]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fill'; S.artVer++; render(); } });
    $('[data-abb-fit]').addEventListener('click', function () { var a = editingArt(); if (a) { a.mode = 'fit'; S.artVer++; render(); } });
    $('[data-abb-center]').addEventListener('click', function () { var a = editingArt(); if (a) { if (a.mode !== 'custom') { var c = cfg(); geom(a, c.Wi, c.Hi); a.mode = 'custom'; } a.rcx = 0.5; a.rcy = 0.5; S.artVer++; render(); } });
    $('[data-abb-bg]').addEventListener('input', function (e) { var a = editingArt(); if (a) { a.bg = e.target.value; S.artVer++; renderArtOnly(); } });
    if (typeof ResizeObserver !== 'undefined') { try { new ResizeObserver(function () { drawLayout(); }).observe(cv.parentNode); } catch (er) {} }
  }

  function renderArtOnly() {
    drawLayout();
    updateArtUi();
    sync3dSoon();
  }

  function updateArtUi() {
    var c = cfg();
    var showBackChoice = c.sides === 2;
    if (!showBackChoice && S.face === 'back') S.face = 'front';
    var a = editingArt();
    $('[data-abb-art-tabs]').hidden = !showBackChoice;
    $('[data-abb-back-choice]').hidden = !(showBackChoice && S.face === 'back');
    $$('[data-abb-face]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-face') === S.face ? 'true' : 'false'); });
    var same = $('[data-abb-back-same]'), diff = $('[data-abb-back-diff]');
    if (same && diff) { same.checked = S.backMode !== 'different'; diff.checked = S.backMode === 'different'; }
    var drop = $('[data-abb-drop]');
    drop.hidden = S.face === 'back' && S.backMode !== 'different';
    var nameEl = $('[data-abb-file-name]');
    nameEl.hidden = !a; nameEl.textContent = a ? ('Selected: ' + a.name) : '';
    var ctl = $('[data-abb-layout-controls]');
    ctl.hidden = !(a && a.img);
    var empty = $('[data-abb-layout-empty]');
    var rw = $('[data-abb-res-warn]');
    rw.hidden = true;
    if (S.face === 'back' && S.backMode !== 'different') { empty.hidden = false; empty.textContent = 'The back shows the same art as the front.'; }
    else if (a && a.loading) { empty.hidden = false; empty.textContent = 'Loading a preview of your file…'; }
    else if (a && a.noPreview) { empty.hidden = true; rw.hidden = false; rw.textContent = noPreviewText(a); }
    else if (a && a.kind !== 'image') { empty.hidden = false; empty.textContent = 'This is a preview of your file. We print from your original, so the sign will look sharper than the preview.'; }
    else if (!a) { empty.hidden = false; empty.textContent = S.design ? 'We\'ll design your sign and email you a proof.' : (S.face === 'back' ? 'No art for the back yet. Upload it above.' : 'No artwork yet. Upload yours above, or let us design it.'); }
    else empty.hidden = true;
    if (lay.canvas) lay.canvas.style.touchAction = (a && a.img) ? 'none' : 'auto';
    if (a && a.img) {
      var g = geom(a, c.Wi, c.Hi);
      var sc = $('[data-abb-scale]');
      var pct = Math.round(100 * g.w / g.fillW);
      sc.value = String(Math.max(10, Math.min(400, pct)));
      $('[data-abb-scale-out]').textContent = pct + '%';
      $('[data-abb-bg]').value = a.bg;
      if (a.kind === 'image' && !/svg/i.test(a.file.type || a.name)) {
        var dpi = Math.round(a.natW / g.w);
        if (dpi < 40) { rw.hidden = false; rw.textContent = 'This image is about ' + dpi + ' pixels per inch at this size, so it will print blurry. Use a bigger image or a PDF, or let us design it.'; }
        else if (dpi < 75) { rw.hidden = false; rw.textContent = 'This image is about ' + dpi + ' pixels per inch at this size. It looks fine from a few steps away but soft up close. 100 or more is best.'; }
      }
    }
  }

  // ---------- render ----------
  function specLines(c, p) {
    var out = [];
    out.push(['Frame', frameLabel(c)]);
    out.push(['Sign size', sizeLabel(c)]);
    out.push(['Signs', signsLabel(c)]);
    if (c.frame) out.push(['Frame color', COLORS[c.color] || c.color]);
    if (S.design) out.push(['Design', 'Ardor designs it (+' + money(p.fee) + ')']);
    out.push(['Quantity', String(c.qty)]);
    return out;
  }

  function sidesNote(c) {
    var m = c.model;
    if (!m.insert) return c.sides === 2 ? 'Your art is printed on vinyl and applied to both sides of the frame.' : 'Your art is printed on vinyl and applied to the front of the frame. The back stays plain white.';
    if (!c.frame) return c.sides === 2 ? 'Two printed 4mm coroplast inserts, one for each side of your frame.' : 'One printed 4mm coroplast insert.';
    return c.sides === 2 ? 'Two printed 4mm coroplast signs, one for each side. Use the same art on both, or different art on the back.' : 'One printed 4mm coroplast sign for the front. The back of the frame stays empty.';
  }

  function render() {
    var c = cfg();
    var p = price(c);
    var m = c.model;

    // frame
    fill($('[data-abb-models]'), MODELS.map(function (mm) {
      var html = '<span class="abb-opt__name">' + esc(mm.name) + '</span><span class="abb-opt__sub">' + esc(mm.sub) + '</span><span class="abb-opt__price">from ' + money(fromPrice(mm)) + '</span>';
      return optBtn({ on: mm.id === m.id, html: html, data: ['model', mm.id], pick: function () { pickModel(mm.id); } });
    }));

    // what you need: frame with signs, or replacement inserts only
    var orderWrap = $('[data-abb-order-wrap]');
    if (orderWrap) orderWrap.hidden = m.orders.length < 2;
    fill($('[data-abb-orders]'), [
      optBtn({ on: c.order === 'frame', data: ['order', 'frame'], html: '<span class="abb-opt__name">Frame with signs</span><span class="abb-opt__sub">The A-frame and your printed signs</span>', pick: function () { set({ order: 'frame' }); } }),
      optBtn({ on: c.order === 'inserts', disabled: m.orders.indexOf('inserts') < 0, data: ['order', 'inserts'], html: '<span class="abb-opt__name">Replacement inserts only</span><span class="abb-opt__sub">New signs for a frame you already have</span>', pick: function () { set({ order: 'inserts' }); } })
    ]);
    setText('[data-abb-order-note]', c.frame
      ? 'You get a new ' + m.name + ' frame with your printed sign' + (c.sides === 2 ? 's' : '') + ', ready to set out.'
      : 'Signs only, no frame. They fit the ' + m.name + ' frame (' + sizeLabel(c) + ').');

    // printed signs
    fill($('[data-abb-sides]'), [
      optBtn({ on: c.sides === 1, data: ['sides', 1], html: '<span class="abb-opt__name">1 side</span><span class="abb-opt__sub">One printed sign, on the front</span>', pick: function () { set({ sides: 1 }); } }),
      optBtn({ on: c.sides === 2, data: ['sides', 2], html: '<span class="abb-opt__name">2 sides</span><span class="abb-opt__sub">Two printed signs, front and back</span>', pick: function () { set({ sides: 2 }); } })
    ]);
    setText('[data-abb-sides-note]', sidesNote(c));

    // frame color
    var colorWrap = $('[data-abb-color-wrap]');
    if (colorWrap) colorWrap.hidden = !(c.frame && m.colors.length > 1);
    fill($('[data-abb-colors]'), m.colors.map(function (col) {
      return optBtn({ chip: true, on: c.color === col, data: ['color', col], label: COLORS[col] || col, pick: function () { set({ color: col }); } });
    }));

    // number the steps that are showing
    var n = 0;
    $$('.abb-step').forEach(function (st) { var b = $('.abb-step__num', st); if (!b) return; if (!st.hidden) n++; b.textContent = String(n || 1); });

    // quantity
    var qI = $('[data-abb-qty]');
    if (document.activeElement !== qI) qI.value = String(c.qty);

    // design
    $('[data-abb-design-brief-wrap]').hidden = !S.design;
    var feeCents = cents('AF-DESIGN');
    setText('[data-abb-design-fee]', '$' + fmt(feeCents / 100));

    // price box
    setText('[data-abb-total]', money(p.charged));
    setText('[data-abb-mbar-total]', money(p.charged));
    setText('[data-abb-dbar-total]', money(p.charged));
    var eachEl = $('[data-abb-each]');
    eachEl.hidden = c.qty < 2 && !S.design;
    eachEl.textContent = (c.qty > 1 ? money(p.unit) + ' each × ' + c.qty : money(p.unit)) + (S.design ? ' + ' + money(p.fee) + ' design' : '');
    var specs = $('[data-abb-specs]');
    if (specs) { specs.textContent = ''; specLines(c, p).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; specs.appendChild(li); }); }
    var warn = $('[data-abb-warn]'); if (warn) { warn.hidden = true; warn.textContent = ''; }

    // viewer chips and tools
    setText('[data-abb-chip-size]', sizeLabel(c) + ' sign');
    setText('[data-abb-chip-mat]', c.frame ? m.name : 'Replacement inserts');
    setText('[data-abb-chip-sides]', c.sides === 2 ? '2 sides' : '1 side');
    setText('[data-abb-flip]', S.back ? 'Show front' : 'Show back');

    updateArtUi();
    drawLayout();
    sync3d();
  }

  // ---------- 3D viewer (window.ArdorAFrame3D, three.js). Everything else works without it. ----------
  var faceCv = { front: null, back: null }, faceSent = { front: '', back: '' }, engSent = '', syncQueued = false;
  function paintFaceCanvas(c, face) {
    var k = Math.min(100, 1400 / Math.max(c.Wi, c.Hi));
    var w = Math.round(c.Wi * k), h = Math.round(c.Hi * k);
    var cv = faceCv[face] || (faceCv[face] = document.createElement('canvas'));
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    var ctx = cv.getContext('2d');
    ctx.setTransform(w / c.Wi, 0, 0, h / c.Hi, 0, 0);
    drawFlat(ctx, c, c.Wi, c.Hi, face === 'back' ? 'back-flat' : 'front', false);
    return cv;
  }
  function sendFace(face, cv) {
    var key = cv ? cv.width + 'x' + cv.height : 'none';
    if (faceSent[face] === key) return;
    faceSent[face] = key;
    eng.setFace(face, cv);
  }
  function sync3d() {
    if (!eng) return;
    var c = cfg();
    try {
      var key = [c.model.id, c.color, c.order, c.sides].join('|');
      if (key !== engSent) { engSent = key; eng.set({ model: c.model.id, color: c.color, order: c.order, sides: c.sides }); }
      sendFace('front', paintFaceCanvas(c, 'front'));
      sendFace('back', c.sides === 2 ? paintFaceCanvas(c, 'back') : null);
      eng.refresh();
    } catch (e) {}
  }
  function sync3dSoon() {
    if (!eng || syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; sync3d(); });
  }
  function view3d(which) { if (eng) { try { eng.view(which); } catch (e) {} } }
  function startEngine() {
    var host = $('[data-abb-canvas]'), nogl = $('[data-abb-nogl]'), hint = $('[data-abb-hint]'), vw = $('[data-abb-viewer]');
    try { eng = (window.ArdorAFrame3D && host) ? window.ArdorAFrame3D.create(host, { background: '#ffffff' }) : null; } catch (e) { eng = null; }
    if (!eng) { if (nogl) nogl.hidden = false; if (hint) hint.hidden = true; return; }
    host.addEventListener('pointerdown', function () { if (vw) vw.classList.add('is-dragging'); if (hint) hint.classList.add('is-gone'); });
    var up = function () { if (vw) vw.classList.remove('is-dragging'); };
    host.addEventListener('pointerup', up); host.addEventListener('pointercancel', up); host.addEventListener('pointerleave', up);
    sync3d();
  }

  // ---------- proof sheet and print files ----------
  function proofCanvas(face, overlayOnly) {
    var c = cfg(), Wi = c.Wi, Hi = c.Hi;
    var long = 1800, cw, ch;
    if (Wi >= Hi) { cw = long; ch = Math.max(60, Math.round(long * Hi / Wi)); } else { ch = long; cw = Math.max(60, Math.round(long * Wi / Hi)); }
    var cv = document.createElement('canvas'); cv.width = cw; cv.height = ch;
    var ctx = cv.getContext('2d');
    ctx.setTransform(cw / Wi, 0, 0, ch / Hi, 0, 0);
    var drewArt = overlayOnly || (!S.design && paintFace(ctx, Wi, Hi, face === 'back' ? 'back-flat' : 'front'));
    if (overlayOnly && hasLayers(layerFace(face === 'back' ? 'back-flat' : 'front'))) window.ArdorAFrameLayers.paint(ctx, Wi, Hi, layerFace(face === 'back' ? 'back-flat' : 'front')); // v2
    if (!drewArt) {
      ctx.fillStyle = '#F1EFEB'; ctx.fillRect(0, 0, Wi, Hi);
      ctx.fillStyle = '#5E5A55'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '600 ' + Math.min(Hi * 0.1, Wi * 0.06) + 'px Arial, sans-serif';
      ctx.fillText(S.design ? 'Ardor designs your artwork' : 'Your artwork', Wi / 2, Hi / 2);
    }
    var u = Math.max(Wi, Hi) / long; // inches per canvas pixel
    ctx.save();
    ctx.setLineDash([]); ctx.lineWidth = u * 7; ctx.strokeStyle = 'rgba(255,255,255,0.85)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([u * 18, u * 12]); ctx.lineWidth = u * 4; ctx.strokeStyle = 'rgba(189,37,44,0.98)';
    ctx.strokeRect(SAFE, SAFE, Wi - SAFE * 2, Hi - SAFE * 2);
    ctx.setLineDash([]);
    ctx.lineWidth = u * 2; ctx.strokeStyle = '#0C0D0D'; ctx.strokeRect(0, 0, Wi, Hi);
    ctx.restore();
    return cv;
  }

  function geomForArt(a, nw, nh, Wi, Hi) {
    var ia = nw / nh, ba = Wi / Hi;
    if (a.kind !== 'image' && !a.img) {
      if (Math.abs(ia - ba) / ba < 0.01) return { x: 0, y: 0, w: Wi, h: Hi };
      var fw = Math.min(Wi, Hi * ia), fh = fw / ia;
      return { x: (Wi - fw) / 2, y: (Hi - fh) / 2, w: fw, h: fh, note: 'The uploaded PDF is a different shape than the sign, so it was placed to fit, centered, with white around it.' };
    }
    var fillW = Math.max(Wi, Hi * ia), fitW = Math.min(Wi, Hi * ia);
    var w = a.mode === 'fill' ? fillW : (a.mode === 'fit' ? fitW : a.rw * Wi);
    var cx = a.mode === 'custom' ? a.rcx * Wi : Wi / 2, cy = a.mode === 'custom' ? a.rcy * Hi : Hi / 2, h = w / ia;
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h };
  }

  function loadPdfTool() {
    if (window.ArdorAFramePDF) return Promise.resolve();
    return new Promise(function (res, rej) {
      var sc = document.createElement('script'); sc.src = CONF.pdfUrl; sc.async = true;
      sc.onload = function () { window.ArdorAFramePDF ? res() : rej(new Error('pdf tool')); }; sc.onerror = function () { rej(new Error('pdf tool')); };
      document.head.appendChild(sc);
    });
  }

  function logoImage() {
    var el = document.querySelector('.site-header__logo img, .header__logo img, header img');
    var src = CONF.logoUrl || (el && (el.currentSrc || el.src));
    if (!src) return Promise.resolve(null);
    return fetch(src).then(function (r) { if (!r.ok) throw new Error('logo'); return r.blob(); }).then(function (bl) {
      return new Promise(function (res) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { res(null); }; im.src = URL.createObjectURL(bl); });
    }).catch(function () { return null; });
  }

  function placementText(a, c) {
    if (!a || !a.img) return '';
    if (a.mode === 'fill') return 'Fill sign (edges may crop)';
    if (a.mode === 'fit') return 'Fit whole image, background ' + a.bg;
    var g = geom(a, c.Wi, c.Hi);
    return 'Custom: art ' + fmt(g.w) + ' x ' + fmt(g.h) + ' in, top-left at ' + fmt(g.x) + ', ' + fmt(g.y) + ' in from sign top-left, background ' + a.bg;
  }
  function artworkLabel() { return S.design ? 'Ardor designs it' + (ART.front ? ' (reference: ' + ART.front.name + ')' : '') : (ART.front ? ART.front.name : (hasLayers('front') ? 'Text and clipart added in the builder' : 'None')); } // v2
  function backLabel() { return S.backMode === 'different' ? (ART.back ? ART.back.name : (S.design ? 'Ardor designs it' : (hasLayers('back') ? 'Text and clipart added in the builder' : 'Different art'))) : 'Same as front'; } // v2

  function proofSpecs(c) {
    var out = [
      ['Frame', frameLabel(c)],
      ['Sign size', sizeLabel(c)],
      ['Signs', signsLabel(c)]
    ];
    if (c.frame) out.push(['Frame color', COLORS[c.color] || c.color]);
    out.push(['Quantity', String(c.qty)]);
    out.push(['Delivery', S.delivery === 'pickup' ? 'Pick up at our Snohomish shop' : 'Ship (free ground)']);
    out.push(['Artwork', artworkLabel()]);
    var pl = !S.design && placementText(ART.front, c); if (pl) out.push(['Placement', pl]);
    if (c.sides === 2) out.push(['Back', backLabel()]);
    var added = layerSummary(c); if (added) out.push(['Added in the builder', added]); // v2
    var brief = ($('[data-abb-design-brief]').value || '').trim(); if (S.design && brief) out.push(['Design brief', brief]);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) out.push(['Notes', notes]);
    return out;
  }

  // ---------- proof sheet shared by the builders (assets/ardor-proofsheet.js, Oct 9 2026): the 3D view on page 1, the print file next to it or on page 2 ----------
function proofViews(c) {
var out = [];
try { sync3d(); } catch (e) {}
if (!eng || typeof eng.snapshot !== 'function') return out;
[['home', 'From the front'], ['back', 'From the back']].forEach(function (v) {
try { var cv = eng.snapshot(1000, 1030, v[0]); if (cv) out.push({ canvas: cv, caption: v[1] }); } catch (e) {}
});
return out;
}
function proofSheet(P, c, mode, o) {
var PS = window.ArdorProofSheet;
if (!PS || typeof PS.build !== 'function') return P.buildProof(o);
o.noun = 'A-frame sign'; o.preview = mode === 'preview'; o.views = proofViews(c);
return PS.build(o).catch(function () { return P.buildProof(o); });
}
function buildFiles(c, approval, proofMode) {
    return loadPdfTool().then(function () {
      var P = window.ArdorAFramePDF, Wi = c.Wi, Hi = c.Hi;
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var out = { notes: [], proof: null, front: null, back: null };
      var dimW = fmt(Wi) + ' in', dimH = fmt(Hi) + ' in';
      // the file used for vector drawing: the PDF/AI itself, or the PDF made from an EPS
      var vectorArt = function (a) {
        if (S.design || !a || a.kind === 'image') return null;
        if (a.src === 'eps' && a.vectorPdf) return { file: new File([a.vectorPdf], 'artwork.pdf', { type: 'application/pdf' }), name: 'artwork.pdf' };
        if (a.src === 'pdf' || a.src === 'ai' || (!a.src && (/\.(pdf|ai)$/i.test(a.name) || /pdf/i.test(a.file.type || '')))) return a;
        return null;
      };
      var mkProofFace = function (label, faceKey, a) {
        var va = vectorArt(a);
        return { label: label, canvas: proofCanvas(faceKey, !!va), fallback: va ? proofCanvas(faceKey, false) : null, wIn: Wi, hIn: Hi, wLabel: dimW, hLabel: dimH, underlay: va ? { art: va, bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } } : null };
      };
      var faces = [mkProofFace(frontLabel(c), 'front', ART.front)];
      if (backDiff) faces.push(mkProofFace('Back', 'back', ART.back));
      var date = (approval && approval.when) || stampLabel(new Date());
      var proofP = logoImage().then(function (logo) {
        return proofSheet(P, c, proofMode, {
          logo: logo, title: 'Ardor A-Frame Proof', panelTitle: 'Your A-frame sign', sideBySide: true,
          legend: 'Dashed red line: keep words and logos inside it. Print size ' + sizeLabel(c) + ', no bleed.',
          approval: approval || null, date: date, faces: faces, specs: proofSpecs(c),
          footer: 'Ardor Printing | 12531 Old Snohomish Monroe Rd., Snohomish, WA 98290 | (425) 629-0796 | ardorprinting.com'
        });
      }).catch(function () { return null; });
      var arts = [ART.front]; if (backDiff) arts.push(ART.back);
      var printable = function (a, i) { return a ? (a.kind === 'image' || !!vectorArt(a)) : hasLayers(i ? 'back' : 'front'); }; // v2: text-only signs print too
      var printP = Promise.resolve();
      if (proofMode === 'preview') { /* PDF button: the proof only, no print files */ } else if (S.design) out.notes.push('Ardor designs the artwork: make print files after the customer approves the design.');
      else if (!arts.every(printable)) out.notes.push('Print files were not made automatically for this file type. Use the original artwork file.');
      else {
        if (arts.some(function (a) { return a && a.src === 'eps'; })) out.notes.push('The customer uploaded an EPS. The print file was made from it by the online converter, so check it against the original EPS before printing.');
        // one PDF per sign, exact sign size. buildPrint takes the size in feet.
        var mkJob = function (a) {
          return { title: 'Ardor A-Frame Print File', stamp: date, W: Wi / 12, H: Hi / 12, holes: [], dotIn: 0.125, faces: [{ art: a.kind === 'image' ? a : vectorArt(a), bg: a.bg || '#FFFFFF', geomFor: function (nw, nh) { return geomForArt(a, nw, nh, Wi, Hi); } }] };
        };
        var keep = function (r) { r.notes.forEach(function (n) { if (out.notes.indexOf(n) < 0) out.notes.push(n); }); return r.blob; };
        printP = layerJob(mkJob, ART.front, 'front', Wi, Hi, out.notes).then(function (j) { return P.buildPrint(j, false); }).then(function (r) { // v2
          out.front = keep(r);
          if (!backDiff) return null;
          return layerJob(mkJob, ART.back, 'back', Wi, Hi, out.notes).then(function (j) { return P.buildPrint(j, false); }).then(function (r2) { out.back = keep(r2); });
        }).catch(function (e) { out.front = null; out.back = null; out.notes.push('Print files could not be made automatically (' + ((e && e.message) || 'error') + '). Use the original artwork file.'); });
      }
      return Promise.all([proofP, printP]).then(function (r) { out.proof = r[0]; return out; });
    });
  }

  // ---------- messages, tracking, stamps ----------
  function toast(msg) {
    var t = $('[data-abb-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function showErr(msg) { var e = $('[data-abb-error]'); if (!e) return; e.textContent = msg; e.hidden = !msg; }

  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name === 'ardor_aframe_added_to_cart' ? 'add_to_cart' : 'generate_lead', { currency: 'USD', value: data.value }); } catch (e) {}
    try { if (window.fbq) window.fbq('track', name === 'ardor_aframe_added_to_cart' ? 'AddToCart' : 'Lead', { currency: 'USD', value: data.value }); } catch (e) {}
  }

  function stampLabel(d) { return d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }); }
  function stampFile(d) {
    var pad = function (n) { return String(n).padStart(2, '0'); }, h = d.getHours(), ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + h12 + '-' + pad(d.getMinutes()) + ' ' + ap;
  }

  // ---------- proof approval and signature ----------
  var approveCtl = null;
  var sigPad = { ink: false, drawing: false, lx: 0, ly: 0, mode: 'draw' };
  var SIG_FONT = '"Dancing Script", "Segoe Script", "Snell Roundhand", "Brush Script MT", cursive';
  function loadSigFont() {
    if (document.querySelector('link[data-abb-sig-font]')) return;
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.setAttribute('data-abb-sig-font', '');
    l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@600&display=swap';
    document.head.appendChild(l);
  }
  function setSigMode(mode) {
    sigPad.mode = mode;
    $$('[data-abb-sig-mode]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-abb-sig-mode') === mode ? 'true' : 'false'); });
    $('[data-abb-sig-type]').hidden = mode !== 'type';
    $('[data-abb-sig-draw]').hidden = mode !== 'draw';
    if (mode === 'draw') sizeSig();
    if (mode === 'type') {
      var t = $('[data-abb-sig-text]'); if (!t.value) t.value = ($('[data-abb-ap-name]').value || '').trim();
      $('[data-abb-sig-preview]').textContent = t.value;
    }
  }
  function typedSigCanvas(text) {
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 260;
    var ctx = cv.getContext('2d'); var size = 120;
    ctx.font = '600 ' + size + 'px ' + SIG_FONT;
    while (ctx.measureText(text).width > 940 && size > 30) { size -= 6; ctx.font = '600 ' + size + 'px ' + SIG_FONT; }
    ctx.fillStyle = '#111111'; ctx.textBaseline = 'middle'; ctx.fillText(text, 30, 140);
    return cv;
  }
  function sizeSig() {
    var cv = $('[data-abb-sig]'); var dpr = Math.min(2, window.devicePixelRatio || 1);
    cv.width = Math.max(200, Math.round(cv.clientWidth * dpr)); cv.height = Math.round(150 * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = 2.6; ctx.strokeStyle = '#111111';
    sigPad.ink = false;
  }
  function bindSig() {
    var cv = $('[data-abb-sig]');
    var pos = function (e) { var r = cv.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
    cv.addEventListener('pointerdown', function (e) { sigPad.drawing = true; var p = pos(e); sigPad.lx = p[0]; sigPad.ly = p[1]; try { cv.setPointerCapture(e.pointerId); } catch (er) {} e.preventDefault(); });
    cv.addEventListener('pointermove', function (e) {
      if (!sigPad.drawing) return;
      var p = pos(e), ctx = cv.getContext('2d');
      ctx.beginPath(); ctx.moveTo(sigPad.lx, sigPad.ly); ctx.lineTo(p[0], p[1]); ctx.stroke();
      sigPad.lx = p[0]; sigPad.ly = p[1]; sigPad.ink = true;
      $('.abb-sig').classList.remove('is-missing');
    });
    var end = function () { sigPad.drawing = false; };
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end);
    $('[data-abb-sig-clear]').addEventListener('click', function () { sizeSig(); });
  }
  function closeApproval(result) {
    var dlg = $('[data-abb-approve]');
    if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
    var ctl = approveCtl; approveCtl = null;
    if (!ctl) return;
    if (result) ctl.resolve(result); else ctl.reject({ cancel: true });
  }
  function openApproval(c) {
    return new Promise(function (resolve, reject) {
      approveCtl = { resolve: resolve, reject: reject };
      var box = $('[data-abb-approve-proof]'); box.textContent = '';
      var backDiff = c.sides === 2 && S.backMode === 'different';
      var faces = [[frontLabel(c), 'front', ART.front]];
      if (backDiff) faces.push(['Back', 'back', ART.back]);
      faces.forEach(function (f) {
        var cv = proofCanvas(f[1], false);
        var fig = document.createElement('figure'); fig.className = 'abb-approve__fig';
        var im = new Image(); im.alt = f[0] + ' of your A-frame sign proof'; im.src = cv.toDataURL('image/jpeg', 0.86);
        var cap = document.createElement('figcaption');
        var isFile = f[2] && f[2].kind !== 'image';
        cap.textContent = f[0] + ': ' + sizeLabel(c) + (isFile ? '. We print from your original file (' + f[2].name + ').' : '');
        fig.appendChild(im); fig.appendChild(cap); box.appendChild(fig);
      });
      var ul = $('[data-abb-approve-specs]'); ul.textContent = '';
      proofSpecs(c).forEach(function (l) { var li = document.createElement('li'); li.innerHTML = '<span>' + esc(l[0]) + '</span><span>' + esc(l[1]) + '</span>'; ul.appendChild(li); });
      $('[data-abb-approve-error]').hidden = true;
      $('[data-abb-ap-colors]').checked = false;
      var dlg = $('[data-abb-approve]');
      loadSigFont();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      setSigMode(coarse ? 'draw' : 'type');
    });
  }
  function submitApproval(e) {
    e.preventDefault();
    var err = $('[data-abb-approve-error]'), msgs = [];
    var name = ($('[data-abb-ap-name]').value || '').trim(), email = ($('[data-abb-ap-email]').value || '').trim(), phone = ($('[data-abb-ap-phone]').value || '').trim();
    if (name.length < 2) msgs.push('your full name');
    if (!/^\S+@\S+\.\S+$/.test(email)) msgs.push('a valid email');
    if ((phone.match(/\d/g) || []).length < 7) msgs.push('a phone number');
    var typed = ($('[data-abb-sig-text]').value || '').trim();
    if (sigPad.mode === 'draw' && !sigPad.ink) { msgs.push('your signature'); $('.abb-sig').classList.add('is-missing'); }
    if (sigPad.mode === 'type' && typed.length < 2) { msgs.push('your typed signature'); $('[data-abb-sig-type]').classList.add('is-missing'); }
    if (!$('[data-abb-ap-colors]').checked) msgs.push('a check in the color box');
    if (msgs.length) { err.textContent = 'Please add ' + msgs.join(', ') + '.'; err.hidden = false; return; }
    var at = new Date(), when = stampLabel(at), mode = sigPad.mode;
    var fontReady = (mode === 'type' && document.fonts && document.fonts.load) ? document.fonts.load('600 60px "Dancing Script"').catch(function () {}) : Promise.resolve();
    fontReady.then(function () {
      var copy;
      if (mode === 'type') copy = typedSigCanvas(typed);
      else { var src = $('[data-abb-sig]'); copy = document.createElement('canvas'); copy.width = src.width; copy.height = src.height; copy.getContext('2d').drawImage(src, 0, 0); }
      closeApproval({ name: name, email: email, phone: phone, when: when, at: at, sig: copy, method: mode === 'type' ? 'typed' : 'drawn', statements: ['I understand printed colors may vary slightly from what I see on my screen.', 'I approve this proof for printing as shown.'] });
    });
  }

  // ---------- cart ----------
  function setupMsg() { return 'Online ordering for this sign is being set up. Call ' + PHONE + ' or request a quote.'; }

  // second cart line: the flat design fee (1 x AF-DESIGN). Tried twice; the sign line already carries "Ardor designs it".
  function addDesignLine(vid) {
    var send = function () {
      return fetch(CONF.cartAddUrl || '/cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1, properties: { 'For': 'A-frame sign design' } })
      }).then(function (r) { if (!r.ok) throw new Error('design fee'); });
    };
    return send().catch(function () { return send(); }).catch(function () { track('ardor_aframe_design_fee_failed', { value: 0 }); });
  }

  function addToCart() {
    showErr('');
    var c = cfg(); var p = price(c);
    var designVar = variantFor('AF-DESIGN');
    if (!p.vid || (S.design && !designVar)) { showErr(setupMsg()); return; }
    if (!S.delivery) {
      var fs = $('.abb-delivery'); fs.classList.add('is-missing');
      showErr('Choose how you want to get your sign: free shipping or free pickup in Snohomish.');
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!ART.front && !S.design && !hasLayers('front')) { showErr('Upload your artwork, or check "Have Ardor design it".'); $('[data-abb-drop]').scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    if (c.sides === 2 && S.backMode === 'different' && !ART.back && !S.design && !hasLayers('back')) { showErr('Upload the art for the back, or choose "Same art on both sides".'); return; }
    var btns = [$('[data-abb-add]'), $('[data-abb-add-m]'), $('[data-abb-add-d]')].filter(Boolean);
    btns.forEach(function (b) { b.disabled = true; b.textContent = 'Adding…'; });
    var done = function () { btns.forEach(function (b) { b.disabled = false; b.textContent = 'Add to cart'; }); };
    var approval = null, emailProof = false;
    var backDiff = c.sides === 2 && S.backMode === 'different';
    var waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
    Promise.all(waits).then(function () {
      emailProof = needsEmailProof();
      return emailProof ? null : openApproval(c);
    }).then(function (ap) {
      approval = ap;
      btns.forEach(function (b) { b.textContent = 'Saving your proof…'; });
      return buildFiles(c, approval);
    }).then(function (files) {
      var fd = new FormData();
      fd.append('id', String(p.vid));
      fd.append('quantity', String(c.qty));
      fd.append('properties[Frame]', frameLabel(c));
      fd.append('properties[Sign size]', sizeLabel(c));
      fd.append('properties[Signs]', signsLabel(c));
      if (c.frame) fd.append('properties[Frame color]', COLORS[c.color] || c.color);
      fd.append('properties[Delivery]', deliveryLabel());
      fd.append('properties[Artwork]', artworkLabel());
      if (c.sides === 2) fd.append('properties[Back]', backLabel());
      var notes = ($('[data-abb-notes]').value || '').trim();
      if (notes) fd.append('properties[Notes]', notes);
      var brief = ($('[data-abb-design-brief]').value || '').trim();
      if (S.design && brief) fd.append('properties[Design brief]', brief);
      var pl = placementText(ART.front, c); if (pl) fd.append('properties[_Art placement]', pl);
      if (backDiff) { var pb = placementText(ART.back, c); if (pb) fd.append('properties[_Back placement]', pb); }
      var stampDate = approval && approval.at ? approval.at : new Date();
      var fileStamp = stampFile(stampDate), labelStamp = (approval && approval.when) || stampLabel(stampDate);
      var ext = function (n) { var m = /\.[A-Za-z0-9]{1,5}$/.exec(n || ''); return m ? m[0].toLowerCase() : ''; };
      var pdfFile = function (blob, name) { return new File([blob], name + ' ' + fileStamp + '.pdf', { type: 'application/pdf' }); };
      var MAXPDF = 25 * 1024 * 1024;
      if (files.proof && approval) fd.append('properties[Ardor A-Frame Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor A-Frame Proof'));
      else if (files.proof) fd.append('properties[_Ardor A-Frame Unsigned Proof - ' + labelStamp + ']', pdfFile(files.proof, 'Ardor A-Frame Unsigned Proof'));
      if (!approval) fd.append('properties[Proof]', S.design ? 'We\'ll email your design proof to approve before printing' : 'We\'ll email you a proof to approve before printing');
      if (approval) {
        fd.append('properties[Approved by]', approval.name);
        fd.append('properties[Approved on]', approval.when);
        fd.append('properties[_Approver email]', approval.email);
        fd.append('properties[_Approver phone]', approval.phone);
      }
      var tooBig = false;
      [['front', 'Front'], ['back', 'Back']].forEach(function (k) {
        var bl = files[k[0]]; if (!bl) return;
        if (bl.size <= MAXPDF) fd.append('properties[_Ardor A-Frame Print File ' + k[1] + ' - ' + labelStamp + ']', pdfFile(bl, 'Ardor A-Frame Print File ' + k[1]));
        else tooBig = true;
      });
      if (tooBig) files.notes.push('A print file was over 25 MB, so it was not attached. Use the original artwork file.');
      var pnote = [];
      if (files.front) pnote.push('Exact sign size ' + sizeLabel(c) + ', no bleed, no marks, 100% scale.' + (c.sides === 2 && !backDiff ? ' Same art on both signs: print the front file twice.' : ''));
      files.notes.forEach(function (n) { pnote.push(n); });
      if (pnote.length) fd.append('properties[_Print file note]', pnote.join(' '));
      if (ART.front) fd.append('properties[Ardor A-Frame Artwork - ' + labelStamp + ']', ART.front.file, 'Ardor A-Frame Artwork ' + fileStamp + ext(ART.front.name));
      if (backDiff && ART.back) fd.append('properties[Ardor A-Frame Artwork Back - ' + labelStamp + ']', ART.back.file, 'Ardor A-Frame Artwork Back ' + fileStamp + ext(ART.back.name));
      fd.append('properties[_spec]', JSON.stringify({ sku: c.sku, m: c.model.id, o: c.order, s: c.sides, c: c.frame ? c.color : '', w: c.Wi, h: c.Hi, d: S.design, q: c.qty, u: p.unit }));
      return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', CONF.cartAddUrl || '/cart/add.js');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.upload.onprogress = function (e) { if (e.lengthComputable && e.total > 200000) { var pct = Math.round(100 * e.loaded / e.total); btns.forEach(function (b) { b.textContent = pct < 100 ? 'Uploading… ' + pct + '%' : 'Adding…'; }); } };
        xhr.onload = function () {
          if (xhr.status >= 200 && xhr.status < 300) return resolve();
          var msg = 'We couldn\'t add this to your cart. Please try again, or request a quote.';
          try { var j = JSON.parse(xhr.responseText); if (j && j.description && xhr.status !== 404) msg = j.description; } catch (e) {}
          if (xhr.status === 404 || xhr.status === 422) msg = setupMsg();
          reject(new Error(msg));
        };
        xhr.onerror = function () { reject(new Error('Network error. Please check your connection and try again.')); };
        xhr.send(fd);
      });
    }).then(function () {
      return S.design && designVar ? addDesignLine(designVar.id) : null;
    }).then(function () {
      track('ardor_aframe_added_to_cart', { value: p.charged, frame: c.model.id, order: c.order, signs: c.sides, quantity: c.qty });
      toast(S.design ? 'Added to your cart. We\'ll email your design proof to approve.' : (emailProof ? 'Added to your cart. We\'ll email you a proof to approve before we print.' : 'Added to your cart. Your signed proof is saved with your order.'));
      window.location.href = CONF.cartUrl || '/cart';
    }).catch(function (err) { if (err && err.cancel) { done(); return; } showErr(err && err.message ? err.message : 'Something went wrong. Please try again.'); done(); });
  }

  // ---------- quote (HubSpot form) ----------
  function summaryText() {
    var c = cfg(); var p = price(c);
    var lines = specLines(c, p).map(function (l) { return l[0] + ': ' + l[1]; });
    lines.push('Sign type: ' + c.model.signType);
    if (ART.front) lines.push('Artwork: ' + ART.front.name + ' (I will send the file)');
    var pl = placementText(ART.front, c); if (pl) lines.push('Placement: ' + pl);
    if (c.sides === 2) lines.push('Back: ' + (S.backMode === 'different' ? (ART.back ? ART.back.name : 'different art') : 'same as front'));
    var brief = ($('[data-abb-design-brief]').value || '').trim(); if (S.design && brief) lines.push('Design brief: ' + brief);
    var notes = ($('[data-abb-notes]').value || '').trim(); if (notes) lines.push('Notes: ' + notes);
    if (S.delivery) lines.push('Delivery: ' + (S.delivery === 'pickup' ? 'Pick up in Snohomish' : 'Ship'));
    lines.push('Online price shown: ' + money(p.charged) + (c.qty > 1 ? ' (' + money(p.unit) + ' each)' : ''));
    return lines.join('\n');
  }

  function openQuote() {
    var dlg = $('[data-abb-quote-dialog]');
    $('[data-abb-quote-summary]').textContent = summaryText();
    $('[data-abb-quote-ok]').hidden = true;
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }

  function copyQuote() {
    var txt = 'A-frame sign from the Ardor A-Frame Sign Builder\n' + summaryText();
    var ok = function () { $('[data-abb-quote-ok]').hidden = false; };
    var fallback = function () {
      var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      var host = $('[data-abb-quote-dialog]') || document.body;
      host.appendChild(ta); ta.select();
      try { document.execCommand('copy'); ok(); } catch (e) {}
      host.removeChild(ta);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, fallback); else fallback();
  }

  // ---------- wiring ----------
  function on(sel, ev, fn) { var el = $(sel); if (el) el.addEventListener(ev, fn); }
  function bind() {
    var qI = $('[data-abb-qty]');
    qI.addEventListener('input', function () { var n = parseInt(qI.value, 10); if (isFinite(n) && n >= 1) { S.qty = Math.min(500, n); render(); } });
    qI.addEventListener('blur', function () { qI.value = String(cfg().qty); });
    on('[data-abb-qty-minus]', 'click', function () { set({ qty: Math.max(1, cfg().qty - 1) }); });
    on('[data-abb-qty-plus]', 'click', function () { set({ qty: Math.min(500, cfg().qty + 1) }); });
    $$('[data-abb-delivery]').forEach(function (r) { r.addEventListener('change', function () { S.delivery = r.value; $('.abb-delivery').classList.remove('is-missing'); showErr(''); }); });
    on('[data-abb-design]', 'change', function (e) { set({ design: e.target.checked }); });
    var fileIn = $('[data-abb-file]');
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; loadFile(f, S.face === 'back' ? 'back' : 'front'); fileIn.value = ''; });
    var drop = $('[data-abb-drop]');
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; loadFile(f, S.face === 'back' ? 'back' : 'front'); });
    $$('[data-abb-face]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.face = b.getAttribute('data-abb-face'); S.back = S.face === 'back';
        render(); view3d(S.back ? 'back' : 'front');
      });
    });
    on('[data-abb-back-same]', 'change', function () { S.backMode = 'same'; S.artVer++; render(); });
    on('[data-abb-back-diff]', 'change', function () { S.backMode = 'different'; S.artVer++; render(); });
    on('[data-abb-flip]', 'click', function () { S.back = !S.back; render(); view3d(S.back ? 'back' : 'front'); });
    on('[data-abb-zoom-in]', 'click', function () { if (eng) { try { eng.zoom(1); } catch (e) {} } });
    on('[data-abb-zoom-out]', 'click', function () { if (eng) { try { eng.zoom(-1); } catch (e) {} } });
    on('[data-abb-reset]', 'click', function () { S.back = false; render(); view3d('home'); });
    on('[data-abb-add]', 'click', addToCart);
    on('[data-abb-add-m]', 'click', addToCart);
    on('[data-abb-add-d]', 'click', addToCart);
    on('[data-abb-quote]', 'click', openQuote);
    on('[data-abb-quote-close]', 'click', function () { var d = $('[data-abb-quote-dialog]'); if (d.close) d.close(); else d.removeAttribute('open'); });
    on('[data-abb-quote-copy]', 'click', copyQuote);
    on('[data-abb-quote-go]', 'click', function () { track('ardor_aframe_quote_request', { value: price(cfg()).charged }); });
    bindLayout();
    bindSig();
    $$('[data-abb-sig-mode]').forEach(function (b) { b.addEventListener('click', function () { setSigMode(b.getAttribute('data-abb-sig-mode')); }); });
    on('[data-abb-sig-text]', 'input', function (e) { $('[data-abb-sig-preview]').textContent = e.target.value; $('[data-abb-sig-type]').classList.remove('is-missing'); });
    on('[data-abb-approve-form]', 'submit', submitApproval);
    on('[data-abb-approve-form]', 'input', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-sig]', 'pointerdown', function () { $('[data-abb-approve-error]').hidden = true; });
    on('[data-abb-approve-close]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve-back]', 'click', function () { closeApproval(null); });
    on('[data-abb-approve]', 'cancel', function (e) { e.preventDefault(); closeApproval(null); });
  }

  // keep the sticky 3D viewer just below the site's stuck menu bar
  var lastTop = 0;
  function headerOffset() {
    var hd = document.getElementById('SiteHeader') || document.querySelector('.site-header, header[role="banner"]');
    if (!hd) return;
    var pos = getComputedStyle(hd).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var r = hd.getBoundingClientRect();
    if (r.height <= 0 || r.top < -1 || r.top > 1 || r.height > window.innerHeight * 0.4) return;
    var top = Math.round(r.bottom + 16);
    if (top !== lastTop) { lastTop = top; root.style.setProperty('--abb-top', top + 'px'); }
  }
  function watchHeader() {
    var queued = false;
    var run = function () { queued = false; headerOffset(); };
    var queue = function () { if (!queued) { queued = true; requestAnimationFrame(run); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    headerOffset();
  }

  function init() {
    watchHeader();
    bind();
    render();
    startEngine();
    window.ArdorAFrameBuilder = { state: S, models: MODELS, cfg: cfg, price: price, render: render, viewer: function () { return eng; } };
    // v2: used by ardor-aframe-layers.js (text, clipart, logo layers and the AI A-frame hand-off). Sizes are in inches (c.Wi x c.Hi).
    window.ArdorAFrameAPI = {
      cfg: cfg, conf: CONF, state: S, root: root, models: MODELS, safe: SAFE, loadFile: loadFile, set: set, render: render, paintFace: paintFace, toast: toast, pickModel: pickModel,
      getArt: function (face) { return ART[face === 'back' ? 'back' : 'front']; },
      setArt: function (face, a) { ART[face === 'back' ? 'back' : 'front'] = a || null; S.artVer++; render(); },
      renderArtOnly: function () { S.artVer++; renderArtOnly(); },
      layoutCanvas: function () { return lay.canvas; },
      layoutScale: function () { return lay.scale; },
      editFace: function () { return S.face === 'back' ? (S.backMode === 'different' ? 'back' : null) : 'front'; },
      artGeom: function (f, Wi, Hi) { var a = typeof f === 'string' ? artFor(f) : f, c = cfg(); return a && a.natW > 0 ? geomForArt(a, a.natW, a.natH, Wi || c.Wi, Hi || c.Hi) : null; }
    };
    window.ArdorAFrameBuilder.proof = { noun: 'A-frame sign', file: 'Ardor A-Frame Proof Preview', stamp: stampFile, make: function () { // the PDF button (assets/ardor-proofsheet.js)
var c = cfg(), waits = [ART.front, ART.back].filter(function (x) { return x && x.ready; }).map(function (x) { return x.ready; });
return Promise.all(waits).then(function () { return buildFiles(c, null, 'preview'); }).then(function (f) { return f && f.proof; });
} };
try { document.dispatchEvent(new CustomEvent('ardor:aframe-api')); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
